const rollContent = () => {
  const content = document.querySelectorAll('.js-roll-content');
  if (content) {
    content.forEach(item => {
      const rollButton = item.querySelector('.js-roll-button');
      const unrollButton = item.querySelector('.js-unroll-button');
      rollButton.addEventListener('click', () => {
        rollButton.classList.add('u-hidden');
        unrollButton.classList.remove('u-hidden');
        item.classList.add('is-expand');
      });
      unrollButton.addEventListener('click', () => {
        unrollButton.classList.add('u-hidden');
        rollButton.classList.remove('u-hidden');
        item.classList.remove('is-expand');
      });
    });
  }
};

export default rollContent;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/roll-content.js